// extracted by mini-css-extract-plugin
module.exports = {"logout":"AccountScreen_logout__1KoHN"};